export const MIN_CHARACTERS = 40;
export const MAX_CHARACTERS = 300;
